import React from 'react';

import { EditConceptFamilyForm } from 'scenes/Gallery/GalleryPage/ConceptFamilies/ConceptFamilyForm';
import * as CONCEPT_FAMILIES from 'scenes/Gallery/GalleryPage/ConceptFamilies/constants';
import { useRemove } from 'scenes/Gallery/GalleryPage/ConceptFamilies/data';

import Actions from './Actions';

const ConceptFamiliesActions = ({
  actions,
  data,
  limit,
  onRemove,
  onOpenChildComponent,
  color,
}) => {
  const { [CONCEPT_FAMILIES.ID]: id, [CONCEPT_FAMILIES.NAME]: name } = data;

  const [remove] = useRemove();

  const handleEdit = () => {
    onOpenChildComponent(EditConceptFamilyForm, {
      id,
    });
  };

  const handleRemove = async () => {
    await remove({ ids: [id], name });
    onRemove?.(data);
  };

  return (
    <Actions
      actions={actions}
      limit={limit}
      onEdit={handleEdit}
      onDelete={handleRemove}
      color={color}
    />
  );
};

export default ConceptFamiliesActions;
